/* eslint-disable prefer-destructuring */
/**
 * A browser logger that provides very convinient logging in production.
 *
 * {@include ../lib/debug/README.md}
 * @category Core Modules
 * @module debug
 * @packageDocumentation
 */

import { o_global } from "@gr-common/common/namespaces";
import { otto } from "@gr-exports/common/nexus";

import type { apm } from "./apm";
import type { GlobalDebug } from "../lib/debug/index.js";
import type { OttoNexus } from "./nexus.js";

export type * from "../lib/debug/index.js";

/**
 * Debug namespace provides various debug utilities
 */
export const debugSync: GlobalDebug = o_global.debug ?? {};

/**
 * Constructs logger instance for given namespace
 */
export const logger = debugSync.logger;
/**
 * Constructs logger scope for given namespace which acts as a prefix
 */
export const scope = debugSync.scope;
/**
 * Enum containing all available log levels
 */
export const Level = debugSync.Level;
/**
 * Returns current logging state
 */
export const status = debugSync.status;

/** @deprecated use {@link OttoNexus.apm.sendCustomError} instead */
export const sendLog: OttoNexus["apm"]["sendCustomError"] = ((otto.apm as typeof apm) ?? {})
  .sendCustomError;
